<div
  class="ui-toast"
  *ngFor="let toast of notify.toasts(); trackBy: trackById"
  [class.ui-toast--success]="toast.kind === 'success'"
  [class.ui-toast--error]="toast.kind === 'error'"
  [class.ui-toast--warning]="toast.kind === 'warning'"
  [class.ui-toast--info]="toast.kind === 'info'"
>
  <span class="ui-toast__dot" aria-hidden="true"></span>
  <span class="ui-grow">{{ toast.text }}</span>
  <button
    type="button"
    ui-icon-button
    icon="i-close"
    size="sm"
    class="ui-toast__close"
    (click)="notify.dismiss(toast.id)"
    aria-label="close"
  ></button>
</div>
